import React, { useContext } from 'react'
import { AssetsContext } from '../../context'
import { Card, CardHeading, CardContent, CardFooter } from '@components/layout/Card'
import { humanizeString } from '@utils/stringMinipulation'
import { PlusCircle } from '@components/Icons/PlusCircle'
import { Button } from '@components/Button'

export const Create = () => {
  const {
    state: { supportedAssets },
    actions: { setAssetTypeToCreate, goToIndex }
  } = useContext(AssetsContext)

  // TODO: Replace this hard coded grid with a better grid implementation
  return (
  <>
    <div
      className='
        grid
        grid-cols-2 gap-2 p-2
        mm:grid-cols-3
        sm:grid-cols-4
        md:grid-cols-5 md:gap-4 md:p-4
        lg:grid-cols-6
        xl:grid-cols-7'>
      {supportedAssets.map((assetType) =>
        <Card key={assetType} darkBorder className='ui-card--asset-types' onClick={setAssetTypeToCreate(assetType)} >
          <CardHeading>
            <h5>{humanizeString(assetType)}</h5>
          </CardHeading>
          <CardContent>
            <PlusCircle />
          </CardContent>
        </Card>
      )}
    </div>
    <CardFooter>
      <Button tertiary onClick={goToIndex}>Back</Button>
    </CardFooter>
  </>
  )
}
